






























import { Component } from 'vue-property-decorator'
import PageWithHeaderFooter from '@/components/common/PageWithHeaderFooter.vue'
import MailRegisterForm from '@/components/register_login/MailRegisterForm.vue'
import OperationResultTips from '@/components/common/OperationResultTips.vue'
import RouterHelper from '@/mixins/RouterHelper.vue'

  @Component({
    components: {
      PageWithHeaderFooter,
      MailRegisterForm,
      OperationResultTips
    }
  })
export default class Register extends RouterHelper {
    private registerSuccess: boolean = false

    /**
     * 点击立即登录按钮
     */
    private loginNowHandler () {
      // @ts-ignore
      this.$router.push(this.getCompleteRouteByPathString('login'))
    }
}
